import AvatarCard from 'components/AvatarCard';
import { Loading } from 'components/LottieFiles';
import Title from 'components/Typography/Title';
import { getMobileOS } from 'helpers/GlobalHelper';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { requestNotificationPermission } from 'serviceWorkerRegistration';
import useData from 'store/useData';
import usePersonalAssistant from 'store/usePesonalAssistant';
import useUser from 'store/useUser';
import { data } from './data';
import { ChoosePaWrapper, Grid } from './Start.styles';
import ClickSound from 'assets/sounds/Tap.wav';
import useSound from 'use-sound';

const ChoosePa = () => {
  const { t } = useTranslation();
  const [play] = useSound(ClickSound);
  const { setUser, isLogged } = useUser();
  const { setPa } = usePersonalAssistant();
  const navigate = useNavigate();
  const { avatars } = useData();

  // handle PA choosing
  const handleChoosePA = async (card: any) => {
    if (getMobileOS() !== 'iOS') requestNotificationPermission();
    setUser({
      avatarImage: card?.media[0]?.location,
      avatarName: card.name,
    });
    setPa({
      avatar: card?.media[0]?.location,
      name: card.name,
    });
    navigate('/start/choose-name');
  };

  useEffect(() => {
    if (isLogged) navigate('/map');
    // eslint-disable-next-line
  }, []);

  return (
    <ChoosePaWrapper>
      <Title renderAs="h1" level={1}>
        {t('choosePa')}
      </Title>
      <Grid>
        {avatars && avatars?.length > 0 ? (
          avatars.slice(0, 4).map((card: any, index: number) => (
            <AvatarCard
              onClick={() => {
                play();
                handleChoosePA(card);
              }}
              key={card.name}
              name={card.name}
              imageSrc={card?.media[0]?.location}
              bgColor={data[index]?.bgColor || ''}
            />
          ))
        ) : (
          <Loading />
        )}
      </Grid>
    </ChoosePaWrapper>
  );
};

export default ChoosePa;
